import { memo, useMemo, type FC } from "react";
import {
  LIST_MEMBERSHIPS,
  PREDICTED_LISTS,
  type ListCondition,
  type ListMembership,
} from "../../CreateSegment.Constants";
import { usePredictedListLabel, useSegmentLabel, useSegmentOptions } from "../../UseSegmentLabel";
import { ConditionFieldsRow, SegmentSelect, type ConditionFieldsProps } from "../ConditionControls";

const ListConditionFields: FC<ConditionFieldsProps<ListCondition>> = ({ condition, onChange }) => {
  const label = useSegmentLabel();
  const listLabel = usePredictedListLabel();
  const membershipOptions = useSegmentOptions("fields.list.memberships", LIST_MEMBERSHIPS);
  const listOptions = useMemo(
    () => PREDICTED_LISTS.map(list => ({ value: list.value, label: listLabel(list.value) })),
    [listLabel]
  );

  return (
    <ConditionFieldsRow label={label("fields.list.label")}>
      <SegmentSelect
        className="segment-builder__control--md"
        aria-label={label("fields.list.membershipAria")}
        value={condition.membership}
        options={membershipOptions}
        onChange={(membership: ListMembership) => onChange({ ...condition, membership })}
      />
      <SegmentSelect
        className="segment-builder__control--grow"
        aria-label={label("fields.list.listAria")}
        value={condition.listName}
        placeholder={label("fields.list.placeholder")}
        options={listOptions}
        showSearch
        optionFilterProp="label"
        onChange={(listName: string) => onChange({ ...condition, listName })}
      />
    </ConditionFieldsRow>
  );
};

export default memo(ListConditionFields);
